import axios from "axios";
import i18next from "./i18n";
import store from "../redux/store";
import { logOut } from "../redux/reducers/authReducer";
import ReactSecurityHelper from "./ReactSecurityHelper";
import CookieHelper from "./CookieHelper";
export default function axiosInstance() {
  const CompanyData = JSON.parse(localStorage.getItem("CompanyData"));
  const AuthedUser = JSON.parse(localStorage.getItem("AuthedUser"));
  const authCookies = CookieHelper.getAuthCookies();
  const { language } = i18next;
  let instance;
  if (CompanyData) {
    const { APIHost, APIPath } = CompanyData;
    const baseURL = `${APIHost}${APIPath}api/ClientUsers/V6`;
    const AccessToken = AuthedUser?.AccessToken || authCookies.AccessToken;
    const { ClientID } = CompanyData;

    // Validate that we have a valid AccessToken
    if (!AccessToken) {
      console.error("No AccessToken found, user may not be properly logged in");
      store.dispatch(logOut());
      localStorage.removeItem("AuthedUser");
      CookieHelper.clearAuthCookies();
      return axios; // Return regular axios to avoid infinite loops
    }

    instance = axios.create({
      baseURL,
      headers: {
        AccessToken: AccessToken,
        "Accept-Encoding": "gzip, deflate, br",
        ApplicationID: "131352",
        CompanyID: ClientID,
        Language: language,
      },
      withCredentials: true, // Enable cookies
    });

    // Request interceptor to add security headers
    instance.interceptors.request.use(
      (config) => {
        const url = config.url || "";
        const baseURL = config.baseURL || "";

        // Resolve fullPath robustly. Handle absolute URLs, regular relative
        // endpoints under the V6 base, and special Free endpoints that live
        // under api/ClientUsers/Free/V6.
        let fullPath;
        if (url.startsWith("http") || url.startsWith("//")) {
          fullPath = url;
        } else if (url.startsWith("/Free/")) {
          // construct: {APIHost}{APIPath}api/ClientUsers/Free/V6/...
          fullPath = `${APIHost}${APIPath}api/ClientUsers/${url.replace(/^\//, "")}`;
        } else {
          // normal relative path appended to V6 base
          fullPath = baseURL + (url.startsWith("/") ? url : `/${url}`);
        }

        const securityHeaders = ReactSecurityHelper.createHeaders(
          config.method || "GET",
          fullPath,
        );

        config.headers = {
          ...config.headers,
          ...securityHeaders,
        };

        // Debug: log outgoing request details for comparison when diagnosing 400 errors
        try {
          console.debug("AXIOS REQUEST", {
            method: config.method,
            url: fullPath,
            headers: config.headers,
            params: config.params,
            data: config.data,
          });
        } catch (e) {
          /* ignore logging errors */
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    instance.interceptors.response.use(
      function (response) {
        try {
          console.debug("AXIOS RESPONSE", {
            url: response.config?.url,
            status: response.status,
            data: response.data,
            headers: response.headers,
          });
        } catch (e) {
          /* ignore logging errors */
        }
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
      },
      function (error) {
        try {
          console.error("AXIOS ERROR", {
            url: error.config?.url,
            status: error.response?.status,
            data: error.response?.data,
            headers: error.response?.headers,
            requestHeaders: error.config?.headers,
          });
        } catch (e) {
          /* ignore logging errors */
        }
        if (error.response.status === 401) {
          store.dispatch(logOut());
          localStorage.removeItem("AuthedUser");
        }
        // Usage
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
      },
    );
    return instance;
  } else {
    instance = axios;
    return instance;
  }
}
